import i18n from "@/Plugins/i18n";

import type { Locale } from "../Model/Domain";

import useI18nStore from "../Store";
import { mergeBaseTranslations } from "../base";

import { LocalStorageService } from "@/Services/LocalStorageService";

import { setLocaleApp } from "@/Utils/Date";
import { LANG_STORAGE_KEY, LOCALE_STORAGE_SERVICE } from "../Model/Constants";

const localeLocalStorageService = new LocalStorageService(LOCALE_STORAGE_SERVICE);

function ActivateLocaleActionHandler(locale: Locale): void {
  const i18nStore = useI18nStore();
  const translations = mergeBaseTranslations(locale.locale, locale.translations);

  i18n.global.setLocaleMessage(locale.locale, translations);
  i18n.global.locale.value = locale.locale;

  setLocaleApp(locale.locale);

  i18nStore.locales.set(locale.locale, locale);
  i18nStore.locale = locale.locale;
  localeLocalStorageService.set(LANG_STORAGE_KEY, locale.locale);
}

export default ActivateLocaleActionHandler;
